import PpSelect from '@/components/Selectors/Select';

export default {
  components: {
    PpSelect
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    themeSelected: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isLoadingTheme: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChangeTheme(theme) {
      this.$emit('change', theme);
    },
    onLoadMoreTheme() {
      this.$emit('loadMoreTheme');
    }
  }
};
